"use strict";
// Plugin SDK types — the contract every Dunea plugin is described by.
//
// A plugin is pure data (this manifest) plus code that lives where it runs:
//   - host half  → compiled into studio / client / ai (trusted, first-party)
//   - app half   → files that ship into the generated app (untrusted: the AI
//                  and the owner can edit them, so nothing secure lives there)
//
// Everything a plugin adds or needs is expressed through EXTENSION POINTS,
// named `<owner>.<name>` and versioned by major (`payments.provider@1`).
// A plugin `declares` points others can fill, `provides` implementations of
// points, and `requires` capabilities — never other plugins by id. That is
// what keeps plugins swappable: Shop requires `payments.checkout@1`, and
// anything that provides it (the Payments plugin today) satisfies Shop.
//
//   declares ──▶ point ◀── provides         requires ──▶ point (+ features)
//
// Core and surfaces declare points too (see ./core-points.ts), so there is a
// single mechanism, one registry and one dependency graph.
Object.defineProperty(exports, "__esModule", { value: true });
